interface TermsProps {
  termsId: string;
}

export const Terms = ({ termsId }: TermsProps) => {
  return (
    <>
      {termsId === "personal" && (
        <>
          <p>
            주식회사 인시스템(이하 "회사")은 「개인정보 보호법」 제15조 및
            제22조에 따라 루틴케어 서비스 제공을 위해 아래와 같이 개인정보를
            수집·이용하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여
            주시기 바랍니다.
          </p>
          1. 수집·이용 목적 <br />
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>회원 가입 및 본인 확인</li>
            <li style={{ listStyle: "disc" }}>루틴케어 서비스 제공 및 운영</li>
            <li style={{ listStyle: "disc" }}>
              회원 관리 및 서비스 이용에 따른 본인 식별
            </li>
            <li style={{ listStyle: "disc" }}>
              고지사항 전달 및 고객 문의 응대
            </li>
            <li style={{ listStyle: "disc" }}>
              부정 이용 방지 및 서비스 부정 사용 행위 제재
            </li>
            <li style={{ listStyle: "disc" }}>
              서비스 개선 및 신규 서비스 개발
            </li>
          </ul>
          2. 수집하는 개인정보 항목 <br />
          필수 항목
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>성명, 생년월일, 성별</li>
            <li style={{ listStyle: "disc" }}>휴대전화번호, 이메일 주소</li>
            <li style={{ listStyle: "disc" }}>아이디(ID), 비밀번호</li>
            <li style={{ listStyle: "disc" }}>본인인증 정보(CI, DI)</li>
          </ul>
          서비스 이용 과정에서 자동 수집되는 정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              서비스 이용 기록, 접속 로그, 쿠키
            </li>
            <li style={{ listStyle: "disc" }}>
              접속 IP 정보, 기기 정보(OS, 기기 모델명)
            </li>
            <li style={{ listStyle: "disc" }}>불량 이용 기록</li>
          </ul>
          3. 개인정보의 보유 및 이용 기간
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              회원 탈퇴 시 또는 동의 철회 시까지 보유·이용합니다. 단, 다음의
              경우 해당 기간 동안 보관합니다.
            </li>
            <li style={{ listStyle: "disc" }}>관련 법령에 의한 정보 보유</li>
            <li style={{ listStyle: "disc" }}>
              계약 또는 청약철회 등에 관한 기록: 5년 (「전자상거래 등에서의
              소비자보호에 관한 법률」)
            </li>
            <li style={{ listStyle: "disc" }}>
              대금결제 및 재화 등의 공급에 관한 기록: 5년 (「전자상거래 등에서의
              소비자보호에 관한 법률」)
            </li>
            <li style={{ listStyle: "disc" }}>
              소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (「전자상거래
              등에서의 소비자보호에 관한 법률」)
            </li>
            <li style={{ listStyle: "disc" }}>
              표시·광고에 관한 기록: 6개월 (「전자상거래 등에서의 소비자보호에
              관한 법률」)
            </li>
            <li style={{ listStyle: "disc" }}>
              웹사이트 방문 기록: 3개월 (「통신비밀보호법」)
            </li>
          </ul>
          4. 동의를 거부할 권리 및 불이익
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              귀하는 위 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다.
              다만, 필수 항목 수집·이용에 동의하지 않을 경우 루틴케어 회원가입
              및 서비스 이용이 제한됩니다.
            </li>
          </ul>
          <br />
          회사정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>회사명 : 주식회사 인시스템</li>
            <li style={{ listStyle: "disc" }}>대표자 : 이근익</li>
            <li style={{ listStyle: "disc" }}>
              주소 : 부산광역시 동구 조방로 22, 803호 (범일동, 파크빌딩)
            </li>
            <li style={{ listStyle: "disc" }}>
              고객센터 : 051-714-6120 (운영시간: 평일 09:00-18:00)
            </li>
            <li style={{ listStyle: "disc" }}>이메일 : help@insystem.co.kr</li>
            <li style={{ listStyle: "disc" }}>
              개인정보 보호책임자: 김광준 <br />
              (kjkim@insystem.co.kr)
            </li>
          </ul>
        </>
      )}

      {termsId === "health" && (
        <>
          <p>
            주식회사 인시스템(이하 "회사")은 「개인정보 보호법」
            제23조(민감정보의 처리 제한) 및 제24조(고유식별정보의 처리 제한)에
            따라 루틴케어 서비스의 건강 루틴 관리 및 AI 분석 기능 제공을 위해
            아래와 같이 건강정보를 처리하고자 합니다.
          </p>
          1. 수집·이용 목적
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              개인 맞춤형 건강 루틴 관리 및 분석
            </li>
            <li style={{ listStyle: "disc" }}>
              AI 기반 건강 상태 분석 및 건강 점수 산정
            </li>
            <li style={{ listStyle: "disc" }}>
              건강 목표 달성률 측정 및 피드백 제공
            </li>
            <li style={{ listStyle: "disc" }}>
              식단, 운동, 복약 등 루틴 실천 데이터 기록 및 관리
            </li>
            <li style={{ listStyle: "disc" }}>
              건강 개선 효과 분석 및 리포트 제공
            </li>
            <li style={{ listStyle: "disc" }}>리워드 포인트 산정 및 지급</li>
          </ul>
          2. 수집하는 건강정보 항목 <br />
          필수 항목
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              기본 건강정보: 신장, 체중, 연령, 성별
            </li>
            <li style={{ listStyle: "disc" }}>
              질환 정보: 만성질환 유무(고혈압, 당뇨, 고지혈증 등)
            </li>
            <li style={{ listStyle: "disc" }}>루틴 실천 정보:</li>
            <li style={{ listStyle: "disc" }}>
              식단 기록(음식 종류, 섭취 시간, 칼로리)
            </li>
            <li style={{ listStyle: "disc" }}>
              복약 기록(약물명, 복용 시간, 복용 여부)
            </li>
          </ul>
          웨어러블 기기 연동 시 수집되는 정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              걸음 수, 이동 거리, 활동 칼로리
            </li>
            <li style={{ listStyle: "disc" }}>
              심박수, 혈압, 혈당(기기 지원 시)
            </li>
            <li style={{ listStyle: "disc" }}>운동량 및 활동 패턴</li>
          </ul>
          AI 분석을 통해 생성되는 정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>건강 점수 및 루틴 준수율</li>
            <li style={{ listStyle: "disc" }}>
              건강 개선 추이 및 예측 분석 결과
            </li>
            <li style={{ listStyle: "disc" }}>맞춤형 건강 루틴 추천 정보</li>
          </ul>
          선택 항목
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              사진 데이터(식단 인증, 운동 인증 사진)
            </li>
            <li style={{ listStyle: "disc" }}>
              음성 입력 데이터(시니어 친화 기능 이용 시)
            </li>
          </ul>
          3. 건강정보의 제3자 제공 <br />
          회사는 수집된 건강정보를 다음과 같이 제3자에게 제공할 수 있습니다.{" "}
          <br />
          제공받는 자
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>보험회사(건강보험 상품 제공)</li>
            <li style={{ listStyle: "disc" }}>
              헬스케어 기업(건강 관련 서비스 제공)
            </li>
            <li style={{ listStyle: "disc" }}>
              지방자치단체(건강증진사업 연계)
            </li>
            <li style={{ listStyle: "disc" }}>제휴 서비스 제공업체</li>
          </ul>
          제공 항목
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              익명화/가명화 처리된 건강 루틴 데이터
            </li>
            <li style={{ listStyle: "disc" }}>AI 분석 결과 및 건강 점수</li>
            <li style={{ listStyle: "disc" }}>루틴 실천률 및 건강 개선 추이</li>
          </ul>
          제공 목적
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              건강관리 서비스 및 건강 상품 추천
            </li>
            <li style={{ listStyle: "disc" }}>데이터 기반 리워드 제공</li>
            <li style={{ listStyle: "disc" }}>보험료 산정 및 보험상품 제공</li>
            <li style={{ listStyle: "disc" }}>
              공공보건 정책 수립 및 지역사회 건강증진사업 지원
            </li>
          </ul>
          제공 방법
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              원칙적으로 익명화 또는 가명화 처리 후 제공
            </li>
            <li style={{ listStyle: "disc" }}>
              실명 제공이 필요한 경우 회원의 별도 동의 획득
            </li>
          </ul>
          보유 및 이용 기간
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>제공 목적 달성 시까지</li>
          </ul>
          4. 건강정보의 보유 및 이용 기간 <br />
          회원 탈퇴 시 또는 동의 철회 시까지 보유·이용합니다. 단, 다음의 경우
          해당 기간 동안 보관합니다.
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              통계 및 연구 목적: 개인식별정보를 제거한 후 영구 보관
            </li>
            <li style={{ listStyle: "disc" }}>
              법령에 따른 보존: 관련 법령에서 정한 기간 동안 보관
            </li>
          </ul>
          5. 건강정보 처리의 안전성 확보 조치 <br />
          회사는 건강정보의 안전한 처리를 위해 다음과 같은 조치를 취합니다.
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              건강정보 암호화(전송 및 저장 시)
            </li>
            <li style={{ listStyle: "disc" }}>접근통제 및 접근권한 관리</li>
            <li style={{ listStyle: "disc" }}>
              건강정보 취급자 최소화 및 정기 교육
            </li>
            <li style={{ listStyle: "disc" }}>개인정보 보호 전담조직 운영</li>
            <li style={{ listStyle: "disc" }}>보안프로그램 설치 및 갱신</li>
            <li style={{ listStyle: "disc" }}>
              AI 분석 알고리즘의 투명성 및 공정성 확보
            </li>
          </ul>
          6. 회원의 권리 <br />
          회원은 다음의 권리를 행사할 수 있습니다.
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              건강정보 열람, 정정, 삭제 요구
            </li>
            <li style={{ listStyle: "disc" }}>건강정보 처리 정지 요구</li>
            <li style={{ listStyle: "disc" }}>동의 철회 및 회원 탈퇴</li>
            <li style={{ listStyle: "disc" }}>AI 분석 결과에 대한 설명 요구</li>
            <li style={{ listStyle: "disc" }}>
              특정 정보제공자로부터의 데이터 수신 거부
            </li>
            <li style={{ listStyle: "disc" }}>
              제3자 제공에 대한 개별 동의 또는 거부
            </li>
          </ul>
          7. 동의를 거부할 권리 및 불이익
          <br />
          귀하는 위 건강정보 처리 및 분석에 대한 동의를 거부할 권리가 있습니다.
          다만, 동의하지 않을 경우 루틴케어의 건강 루틴 관리, AI 분석, 리워드
          지급 등 핵심 서비스 이용이 제한됩니다.
          <br />
          8. 데이터 수익 환원
          <br />
          회사는 회원의 건강정보를 제3자에게 제공하여 발생한 수익의 일부를
          리워드 포인트 형태로 회원에게 환원합니다. 리워드 포인트의 산정 기준 및
          지급 방법은 별도의 리워드 정책에 따릅니다.
          <br />
          <br />
          회사정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>회사명 : 주식회사 인시스템</li>
            <li style={{ listStyle: "disc" }}>대표자 : 이근익</li>
            <li style={{ listStyle: "disc" }}>
              주소 : 부산광역시 동구 조방로 22, 803호 (범일동, 파크빌딩)
            </li>
            <li style={{ listStyle: "disc" }}>
              고객센터 : 051-714-6120 (운영시간: 평일 09:00-18:00)
            </li>
            <li style={{ listStyle: "disc" }}>이메일 : help@insystem.co.kr</li>
            <li style={{ listStyle: "disc" }}>
              개인정보 보호책임자: 김광준 <br />
              (kjkim@insystem.co.kr)
            </li>
          </ul>
        </>
      )}
      {termsId === "mydata" && (
        <>
          <p>
            제1조 (목적)
            <br />본 약관은 회원이 루틴케어(이하 "서비스")의 건강 데이터 통합
            관리 및 분석 서비스를 이용함에 있어 「개인정보 보호법」,
            「정보통신망 이용촉진 및 정보보호 등에 관한 법률」에 따라 회원의
            건강 관련 개인정보를 수집·이용·제공하는 것에 대한 동의 사항을
            규정함을 목적으로 합니다.
          </p>
          <p>제2조 (용어의 정의)</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              “루틴케어”란 주식회사 인시스템이 제공하는 AI 기반 건강 루틴 관리
              및 리워드 플랫폼을 의미합니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              “건강 데이터”란 회원의 건강 관리를 위해 수집·분석되는 식단, 운동,
              복약, 생체정보 등 건강 관련 모든 정보를 말합니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              “마이데이터”란 회원 본인의 건강 데이터를 통합하여 조회·관리하고
              이를 기반으로 맞춤형 건강 관리 서비스를 제공하는 것을 의미합니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              “정보제공자”란 회원의 건강 데이터를 보유하고 있는 의료기관,
              웨어러블 기기 제조사, 건강관리 앱 사업자 등을 말합니다.
            </li>
          </ul>
          <p>제3조 (건강 데이터의 수집·이용)</p>
          회사는 루틴케어 서비스 제공을 위하여 다음 각 호의 건강 데이터를
          수집·이용합니다.
          <br />
          1. 수집·이용 목적
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              회원의 건강 루틴 데이터 통합 관리
            </li>
            <li style={{ listStyle: "disc" }}>
              AI 기반 건강 상태 분석 및 점수화
            </li>
            <li style={{ listStyle: "disc" }}>맞춤형 건강 관리 루틴 추천</li>
            <li style={{ listStyle: "disc" }}>
              건강 목표 달성률 분석 및 피드백 제공
            </li>
            <li style={{ listStyle: "disc" }}>리워드 포인트 산정 및 지급</li>
            <li style={{ listStyle: "disc" }}>
              건강 개선 효과 분석 및 리포트 제공
            </li>
          </ul>
          <p>수집·이용할 건강 데이터</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              개인식별정보: 성명, 생년월일, 성별, 연락처, CI/DI
            </li>
            <li style={{ listStyle: "disc" }}>
              건강상태정보: 신장, 체중, 혈압, 혈당, 만성질환 정보
            </li>
            <li style={{ listStyle: "disc" }}>
              루틴 실천정보: 식단 기록, 복약 기록, 운동 기록, 수면 기록
            </li>
            <li style={{ listStyle: "disc" }}>
              웨어러블 연동정보: 걸음 수, 심박수, 활동량, 소모 칼로리
            </li>
            <li style={{ listStyle: "disc" }}>
              AI 분석 결과: 건강 점수, 루틴 준수율, 건강 개선 추이
            </li>
            <li style={{ listStyle: "disc" }}>
              기타: 사진 데이터(식단, 운동 인증), 음성 입력 데이터
            </li>
          </ul>
          <p>보유·이용 기간</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              회원 탈퇴 시 또는 동의 철회 시까지
            </li>
            <li style={{ listStyle: "disc" }}>
              관련 법령에 따라 보존할 필요가 있는 경우 해당 기간까지 보관
            </li>
            <li style={{ listStyle: "disc" }}>
              건강 데이터 분석 및 통계 목적의 경우 개인식별정보를 제거한 후 보관
            </li>
          </ul>
          <p>제4조 (건강 데이터의 제3자 제공)</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              제공받는 자: 보험회사, 헬스케어 기업, 지방자치단체, 제휴 서비스
              제공업체
            </li>
            <li style={{ listStyle: "decimal" }}>
              제공 목적:
              <li style={{ listStyle: "disc" }}>
                건강관리 서비스 및 건강 상품 추천
              </li>
              <li style={{ listStyle: "disc" }}>데이터 기반 리워드 제공</li>
              <li style={{ listStyle: "disc" }}>
                보험료 산정 및 보험상품 제공
              </li>
              <li style={{ listStyle: "disc" }}>
                공공보건 정책 수립 및 지역사회 건강증진사업 지원
              </li>
            </li>
          </ul>
          <p>제공 항목 : 제3조 명시 데이터 중 필요한 최소 정보</p>
          <p>제공 방법 : 익명화 또는 가명화 처리 후 제공</p>
          <p>보유 · 이용 기간 : 제공 목적 달성 시까지</p>
          <p>제5조 (정보제공자로부터의 정보 수신)</p>
          <p>
            회사는 루틴케어 서비스 제공을 위하여 다음 각 호의 정보제공자로부터
            회원의 건강 데이터를 전송받습니다.
          </p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>웨어러블 기기 제조사</li>
            <li style={{ listStyle: "decimal" }}>
              건강관리 앱 및 플랫폼 사업자
            </li>
            <li style={{ listStyle: "decimal" }}>의료기관 및 건강검진센터</li>
            <li style={{ listStyle: "decimal" }}>약국 및 복약 관리 시스템</li>
            <li style={{ listStyle: "decimal" }}>식단 및 영양 분석 서비스</li>
            <li style={{ listStyle: "decimal" }}>
              운동 및 피트니스 관련 서비스
            </li>
            <li style={{ listStyle: "decimal" }}>
              기타 건강 데이터 보유 사업자
            </li>
          </ul>
          <p>제6조 (회원의 권리)</p>
          <p>회원은 다음 각 호의 권리를 가집니다.</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              건강 데이터 전송요구 및 전송정지 요구
            </li>
            <li style={{ listStyle: "decimal" }}>
              제공된 데이터 열람·정정·삭제 요구
            </li>
            <li style={{ listStyle: "decimal" }}>
              건강 데이터 수집·이용·제공 동의 철회
            </li>
            <li style={{ listStyle: "decimal" }}>
              AI 분석 결과 및 건강 점수에 대한 설명 요구
            </li>
            <li style={{ listStyle: "decimal" }}>
              특정 정보제공자로부터의 데이터 수신 거부
            </li>
            <li style={{ listStyle: "decimal" }}>
              제3자 제공에 대한 개별 동의 또는 거부
            </li>
            <li style={{ listStyle: "decimal" }}>
              루틴케어 서비스 이용 중단 및 데이터 삭제 요구
            </li>
          </ul>
          <p>제7조 (동의의 철회)</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              회원은 언제든지 본 동의를 철회할 수 있습니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              동의 철회는 루틴케어 앱 내 설정 메뉴, 고객센터(전화, 이메일)를
              통해 가능합니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              동의 철회 시 건강 데이터 수집 및 AI 분석, 리워드 지급 등 루틴케어
              서비스 이용이 제한될 수 있습니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              동의 철회 시 즉시 데이터 제3자 제공이 중단되며, 이미 제공된
              데이터에 대해서는 해당 제공받은 자에게 삭제를 요청합니다.
            </li>
          </ul>
          <p>제8조 (건강 데이터의 안전성 확보조치)</p>
          <p>
            회사는 건강 데이터의 안전성 확보를 위하여 다음 각 호의 조치를
            취합니다.
          </p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              건강 데이터 암호화 (전송 및 저장 시)
            </li>
            <li style={{ listStyle: "decimal" }}>
              접근통제 및 접근권한 관리 시스템 운영
            </li>
            <li style={{ listStyle: "decimal" }}>
              건강 데이터 취급 직원의 최소화 및 정기 교육
            </li>
            <li style={{ listStyle: "decimal" }}>
              개인정보 보호 전담조직 및 개인정보 보호책임자 지정·운영
            </li>
            <li style={{ listStyle: "decimal" }}>
              보안프로그램 설치 및 주기적 갱신
            </li>
            <li style={{ listStyle: "decimal" }}>
              해킹, 바이러스 등에 대비한 기술적 보호조치
            </li>
            <li style={{ listStyle: "decimal" }}>
              건강 데이터 접근 기록의 보관 및 위조·변조 방지
            </li>
            <li style={{ listStyle: "decimal" }}>
              AI 분석 알고리즘의 투명성 및 공정성 확보
            </li>
          </ul>
          <p>제9조 (손해배상)</p>
          <p>
            회사는 루틴케어 서비스 제공과 관련하여 회사의 귀책사유로 회원에게
            손해가 발생한 경우 「개인정보 보호법」, 「정보통신망 이용촉진 및
            정보보호 등에 관한 법률」 등 관련 법령에 따라 손해배상 책임을
            부담합니다.
          </p>
          <p>제10조 (분쟁해결)</p>
          <p>
            본 약관과 관련된 분쟁에 대해서는 「개인정보 보호법」에 따른 개인정보
            분쟁조정위원회의 분쟁조정, 「소비자기본법」에 따른
            소비자분쟁조정위원회의 분쟁조정 등을 통해 해결할 수 있습니다.
          </p>
          <p>제11조 (데이터 수익 환원)</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "decimal" }}>
              회사는 회원의 건강 데이터를 제3자에게 제공하여 발생한 수익의
              일부를 리워드 포인트 형태로 회원에게 환원합니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              리워드 포인트의 산정 기준 및 지급 방법은 별도의 리워드 정책에
              따릅니다.
            </li>
            <li style={{ listStyle: "decimal" }}>
              회원은 언제든지 데이터 제공 및 수익 환원 내역을 조회할 수
              있습니다.
            </li>
          </ul>
          <p>부칙</p>
          <p>본 약관은 2025년 1월 1일부터 시행합니다.</p>
          <br />
          회사정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>회사명 : 주식회사 인시스템</li>
            <li style={{ listStyle: "disc" }}>대표자 : 이근익</li>
            <li style={{ listStyle: "disc" }}>
              주소 : 부산광역시 동구 조방로 22, 803호 (범일동, 파크빌딩)
            </li>
            <li style={{ listStyle: "disc" }}>
              고객센터 : 051-714-6120 (운영시간: 평일 09:00-18:00)
            </li>
            <li style={{ listStyle: "disc" }}>이메일 : help@insystem.co.kr</li>
            <li style={{ listStyle: "disc" }}>
              개인정보 보호책임자: 김광준 <br />
              (kjkim@insystem.co.kr)
            </li>
          </ul>
        </>
      )}
      {termsId === "mkt" && (
        <>
          <p>
            주식회사 인시스템(이하 "회사")은 「정보통신망 이용촉진 및 정보보호
            등에 관한 법률」에 따라 회원에게 다양한 마케팅 정보를 제공하기 위해
            아래와 같이 개인정보를 수집·이용하고자 합니다.
          </p>
          <p>1. 수집·이용 목적</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              루틴케어 서비스 관련 신규 기능 및 업데이트 안내
            </li>
            <li style={{ listStyle: "disc" }}>
              이벤트, 프로모션, 할인 혜택 등 마케팅 정보 제공
            </li>
            <li style={{ listStyle: "disc" }}>
              맞춤형 건강 콘텐츠 및 건강 정보 제공
            </li>
            <li style={{ listStyle: "disc" }}>제휴사 서비스 및 상품 안내</li>
            <li style={{ listStyle: "disc" }}>설문조사 및 고객 의견 수렴</li>
          </ul>
          <p>2. 수집하는 개인정보 항목</p>
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              성명, 휴대전화번호, 이메일 주소
            </li>
            <li style={{ listStyle: "disc" }}>서비스 이용 기록 및 관심 분야</li>
            <li style={{ listStyle: "disc" }}>건강 관심사 및 선호 정보</li>
          </ul>
          <p>3. 마케팅 정보 수신 방법</p>
          수신 채널
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>앱 푸시 알림</li>
          </ul>
          회원은 수신 채널별로 선택적으로 동의하거나 거부할 수 있습니다.
          <p>4. 개인정보의 보유 및 이용 기간</p>
          동의일로부터 회원 탈퇴 시 또는 마케팅 수신 동의 철회 시까지
          보유·이용합니다.
          <p>5. 동의를 거부할 권리 및 불이익</p>
          귀하는 마케팅 정보 수신에 대한 동의를 거부할 권리가 있습니다. 마케팅
          수신 동의는 선택사항이며, 동의하지 않아도 루틴케어 서비스 이용에는
          제한이 없습니다. 다만, 마케팅 정보 수신에 동의하지 않을 경우 각종
          이벤트, 프로모션, 혜택 정보를 받아보실 수 없습니다.
          <p>6. 마케팅 수신 동의 철회</p>
          회원은 언제든지 다음의 방법으로 마케팅 수신 동의를 철회할 수 있습니다.
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>
              루틴케어 앱 내 설정 &gt; 알림 설정에서 변경
            </li>
            <li style={{ listStyle: "disc" }}>
              수신한 마케팅 메시지 내 '수신거부' 링크 클릭
            </li>
            <li style={{ listStyle: "disc" }}>
              고객센터 유선 또는 이메일을 통한 요청
            </li>
            <li style={{ listStyle: "disc" }}>고객센터: 051-714-6120</li>
            <li style={{ listStyle: "disc" }}>이메일: help@insystem.co.kr</li>
          </ul>
          <p>7. 야간 마케팅 수신 제한</p>
          회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제50조에
          따라 오후 9시부터 다음날 오전 8시까지는 마케팅 목적의 광고성 정보를
          전송하지 않습니다. 단, 회원이 별도로 야간 수신을 동의한 경우는 예외로
          합니다.
          <br />
          <br />
          회사정보
          <ul style={{ paddingLeft: "20px" }}>
            <li style={{ listStyle: "disc" }}>회사명 : 주식회사 인시스템</li>
            <li style={{ listStyle: "disc" }}>대표자 : 이근익</li>
            <li style={{ listStyle: "disc" }}>
              주소 : 부산광역시 동구 조방로 22, 803호 (범일동, 파크빌딩)
            </li>
            <li style={{ listStyle: "disc" }}>
              고객센터 : 051-714-6120 (운영시간: 평일 09:00-18:00)
            </li>
            <li style={{ listStyle: "disc" }}>이메일 : help@insystem.co.kr</li>
            <li style={{ listStyle: "disc" }}>
              개인정보 보호책임자: 김광준 <br />
              (kjkim@insystem.co.kr)
            </li>
          </ul>
        </>
      )}
    </>
  );
};
